export default __webpack_public_path__ + "static/media/testimonial2.d927c36e.png";